import React from 'react';
import { FadeIn } from './FadeIn';
interface SectionHeaderProps {
  eyebrow: string;
  title?: string;
  centered?: boolean;
  className?: string;
}
export function SectionHeader({
  eyebrow,
  title,
  centered = false,
  className = ''
}: SectionHeaderProps) {
  return <div className={`mb-12 ${centered ? 'text-center' : ''} ${className}`} data-id="element-156">
      <FadeIn delay={0.1} data-id="element-157">
        <div className={`flex items-center gap-4 mb-4 ${centered ? 'justify-center' : ''}`} data-id="element-158">
          {!centered && <div className="h-px w-8 bg-gold" data-id="element-159" />}
          <span className="text-gold font-sans text-xs font-bold tracking-[0.2em] uppercase" data-id="element-160">
            {eyebrow}
          </span>
          {centered && <div className="h-px w-8 bg-gold" data-id="element-161" />}
        </div>
      </FadeIn>

      {title && <FadeIn delay={0.2} data-id="element-162">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-emerald-900 leading-tight" data-id="element-163">
            {title}
          </h2>
        </FadeIn>}
    </div>;
}